import React from "react";

const SuccessMessage = (props) => {
	return (
		<div className="w-full max-w-sm border rounded-md h-12 text-sm flex items-center">
			<div
				className={"bg-green h-full w-2 rounded-l-md justify-self-center"}
			></div>
			<p className={"ml-3 text-gray"}>
				<span className={"text-green uppercase font-bold"}>Edukalt:</span>{" "}
				{props.message}
			</p>
		</div>
	);
};

export default SuccessMessage;